import { Component, EventEmitter, inject, Output } from '@angular/core';
import { AuthService } from '../../../core/services/auth.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-popup-logout',
  imports: [TranslateModule],
  templateUrl: './popup-logout.component.html',
  styleUrl: './popup-logout.component.css',
})
export class PopupLogoutComponent {
  private readonly authService = inject(AuthService);
  @Output() close = new EventEmitter<void>();

  ngOnInit(): void {
    document.body.style.overflow = 'hidden';
  }

  closePopup() {
    document.body.style.overflow = '';
    this.close.emit();
  }

  logout() {
    document.body.style.overflow = '';
    this.close.emit();
    this.authService.logout().subscribe({
      next: () => {},
      error: (err) => console.error('Logout Error:', err),
    });
  }
}
